import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class PaymentFilesApi {
  static downloadTransmittedFile = (fileId) => {
    return axios.get(
      `${API_BASE_URL}/payment-files/transmitted/${fileId}/download`,
      {
        responseType: 'blob',
      },
    );
  };

  static triggerFileDownload = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };
}
